<template>
  <div class="sn-f-b-s homepage">
    <sn-navigator id="ZXCZ" :initial="perpetual.FUNCTION_ID_MZCZ"></sn-navigator>
    <div class="sn-f-1 sn-f-col-b-s homepage-region">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_MZCZ)
      }]"></sn-breadcrumb>
      <div class="sn-f-b-e sn-title operate">
        <div class="sn-f-s-c">
          <div class="sn-f-c-c sn-pointer title-caption"
          :class="{'interaction': $route.path === '/recharge/out/homepage/recharge'}" @click="navigateUrl('/recharge/out/homepage/recharge');">
            {{ $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_MZCZ) }}
          </div>
          <div class="sn-f-c-c sn-pointer title-caption"
          :class="{'interaction': $route.path === '/recharge/out/homepage/record'}" @click="navigateUrl('/recharge/out/homepage/record');">
            {{ $sn.getConfig('outRechargeLabel') }}记录
          </div>
        </div>
      </div>
      <div class="sn-f-1 homepage-sub">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import HomepageMixin from '@/common/mixin/homepage-mixin';

export default {
  mixins: [HomepageMixin],
  watch: {
    '$route.path': {
      handler: function(path) {
        let title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_MZCZ);
        if (path === '/recharge/out/homepage/record') {
          title = this.$sn.getConfig('outRechargeLabel') + '记录';
        }
        document.title = title;
        this.$route.meta.title = title;
      },
      immediate: true
    }
  },
  methods: {
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === this.$route.path) return false;
      if (url === '') {
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/pages/recharge/recharge";
</style>
